<template>
    <div class="popup" :class="{ 'icloud-popup': isICloudGuide }" v-show="cloudDialog" v-cloak id="addCloudPopup">
        <div v-if="cloudName == 'egnyte'">
            <div id="addEgnyteCloud" class="content" ref="addEgnyteCloud"
                :class="[multipleChoiceArr.includes(cloudName) ? 'amazonS3-content' : '', specialTipsCloud.includes(cloudName) ? 'threeInput-content' : '']"
                :style="{ height: tipShow ? boxHeight : getStyleHeight(cloudName) }">
                <div class="title">
                    <span> {{ $t('language.common.addCloud') }}</span>
                    <div class="icon white-close dialog-close"
                        @click="cloudDialog= false, connect = false,closeEditCloud()"></div>
                </div>
                <div class="add-egnyteCloud-cont">
                    <div class="add-cloud-cont-top">
                        <div class="add-cloud-drive-position">
                            <div class="cloud add-cloud-size" :class="cloudIcon"></div>
                            <div class="add-cloud-text">
                                {{ $t('language.addCloud.' + cloudName) }}
                            </div>
                        </div>
                    </div>
                    <div class="add-egnyteCloud-cont-body" :class="cloudName == 'amazonS3' ? 'amazonS3-body' : ''">
                        <div class="cloud-cont add-egnyte-des" v-show="cloudName == 'egnyte'">
                            <div class="icon-util egnyte-tip "> </div>
                            <div class="add-egnyteTip" style="position:relative;left:10Px;"
                                v-html="$t('language.popup.addCloudPopup.egnyteTip')"></div>
                        </div>
                        <div class="cloud-cont">
                            <div class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.displayName') }}</div>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="inputCloudNameValue" class="cloud-cont-input"
                                :placeholder="$t('language.addCloud.' + cloudName)"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                            <font class="cloud-cont-name">{{ $t('language.popup.email') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="email" class="cloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="password"
                                v-model="password" class="cloud-cont-input">
                        </div>

                        <button class="add-drive-submit"
                            :style="{ bottom: passwordArr.includes(cloudName) ? -5 + 'px' : '' }" @click="addDrive"
                            v-show="cloudName != 'iCloudPhotos' || cloudName != 'iCloudDrive'">
                            <span v-show="!connect && !localeArr.includes($i18n.locale)">{{ $t('language.common.add')
                            }}&nbsp;&nbsp;{{ $t('language.addCloud.' + cloudName) }}</span>
                            <span v-show="!connect && localeArr.includes($i18n.locale)">{{ $t('language.addCloud.' +
                                cloudName) }}&nbsp;&nbsp;{{ $t('language.common.add') }}</span>
                            <span v-show="connect">{{ $t('language.common.connecting') }}
                                <span class="cloudDotting"></span>
                            </span>
                        </button>

                        <!-- 如果云盘类型为egnyte -->
                        <div class="cloud-cont" v-show="cloudName == 'egnyte'">
                            <font class="cloud-cont-name">{{ $t('language.popup.domain') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="domain" class="cloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'egnyte'">
                            <font class="cloud-cont-name">{{ $t('language.popup.key') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="key" class="cloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'egnyte'">
                            <font class="cloud-cont-name">{{ $t('language.popup.secret') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="secret" class="cloud-cont-input">
                        </div>
                        <div class="question-mark addwebdav-icon-position" v-show="cloudName == 'egnyte'"
                            style="positon:relative;" @mouseout="explanShow = false" @mouseover="explanShow = true">
                            <div class="icon-util questions "> </div>
                            <div class="egnyte-explanation explanation">
                                <font v-html="$t('language.popup.addCloudPopup.' + cloudName + 'Question')"></font>
                            </div>
                        </div>

                        <div v-show="!unTips.includes(cloudName)">
                            <div style="cursor:pointer;" @click="tipShow = !tipShow"><span class="add-cloud-tips">{{
                                $t('language.popup.tips') }}</span>
                                <span class="icon-util folding-panel slide"
                                    :class="tipShow ? 'folding-panel-up' : 'folding-panel-down'"></span>
                            </div>
                            <div class="add-drive-footer">
                                <transition name="tip-slide" v-cloak>
                                    <div class="add-cloud-info" v-show="tipShow" id="container" ref=container>
                                        <span>{{ $t('language.popup.addCloudPopup.' + cloudName + 'Tips') | getStrValue
                                        }}</span>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="cloudName == 'Icedrive'">
            <div id="addIcedriveCloud" class="content" ref="addIcedriveCloud"
                :class="[multipleChoiceArr.includes(cloudName) ? 'amazonS3-content' : '', specialTipsCloud.includes(cloudName) ? 'threeInput-content' : '']"
                :style="{ height: tipShow ? boxHeight : getStyleHeight(cloudName) }">
                <div class="title">
                    <span> {{ $t('language.common.addCloud') }}</span>
                    <div class="icon white-close dialog-close"
                        @click="cloudDialog= false, connect = false,closeEditCloud()"></div>
                </div>
                <div class="add-icedrive-cont">
                    <div class="add-cloud-cont-top">
                        <div class="add-cloud-drive-position">
                            <div class="cloud add-cloud-size" :class="cloudIcon"></div>
                            <div class="add-cloud-text">
                                {{ $t('language.addCloud.' + cloudName) }}
                            </div>
                        </div>
                    </div>
                    <div class="add-icedrive-cont-body" :class="cloudName == 'amazonS3' ? 'amazonS3-body' : ''">
                        <div class="cloud-cont add-icedrive-des" v-show="cloudName == 'Icedrive'">
                            <div class="icon-util icedrive-tip "> </div>
                            <div class="add-icedriveTip" style="position:relative;left:10Px;">
                                <span class="text-line" v-html="$t('language.popup.addCloudPopup.icedriveTip')"></span><br>
                                <span class="text-line" v-html="$t('language.popup.addCloudPopup.icedriveTip1')"></span><br>
                                <span class="text-line" v-html="$t('language.popup.addCloudPopup.icedriveTip2')"></span>
                            </div>
                        </div>
                        <div class="cloud-cont">
                            <div class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.displayName') }}</div>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="inputCloudNameValue" class="cloud-cont-input"
                                :placeholder="$t('language.addCloud.' + cloudName)"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div v-show="threeInput.includes(cloudName)">
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.email') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text" v-model="email"
                                    class="cloud-cont-input">
                            </div>
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="password"
                                    v-model="password" class="cloud-cont-input">
                            </div>
                        </div>
                        <button class="add-drive-submit"
                            :style="{ bottom: passwordArr.includes(cloudName) ? -5 + 'px' : '' }" @click="addDrive"
                            v-show="cloudName != 'iCloudPhotos' || cloudName != 'iCloudDrive'">
                            <span v-show="!connect && !localeArr.includes($i18n.locale)">{{ $t('language.common.add')
                            }}&nbsp;&nbsp;{{ $t('language.addCloud.' + cloudName) }}</span>
                            <span v-show="!connect && localeArr.includes($i18n.locale)">{{ $t('language.addCloud.' +
                                cloudName) }}&nbsp;&nbsp;{{ $t('language.common.add') }}</span>
                            <span v-show="connect">{{ $t('language.common.connecting') }}
                                <span class="cloudDotting"></span>
                            </span>
                        </button>
                    </div>
                </div>


            </div>
        </div>
        <div v-else-if="isICloudGuide">
            <div id="addCloud" class="content icloud-content" ref="addCloud" v-if="!isTempClose"
                role="dialog" aria-modal="true" :aria-label="icloudGuideTitle">
                <div class="title icloud-title">
                    <span>{{ icloudGuideTitle }}</span>
                    <button type="button" class="icon white-close icloud-close"
                        :aria-label="$t('language.common.close')" @click="cloudDialog = false, connect = false, closeEditCloud()"></button>
                </div>
                <div class="icloud-body">
                    <div class="icloud-guide-intro">{{ $t('language.popup.addCloudPopup.iCloudGuideIntro', { cloud: $t('language.addCloud.' + cloudName) }) }}</div>
                    <div class="icloud-guide-descriptions">
                        <div class="icloud-guide-description" :class="{ active: icloudGuideStep === 1 }" :aria-hidden="icloudGuideStep !== 1">
                            <div class="icloud-guide-heading">{{ $t('language.popup.addCloudPopup.iCloudGuideStep1') }}</div>
                            <strong>{{ $t('language.popup.addCloudPopup.iCloudGuideIOS') }}</strong>
                            <div>{{ $t('language.popup.addCloudPopup.iCloudGuideIOSInstructions') }}</div>
                            <strong>{{ $t('language.popup.addCloudPopup.iCloudGuideMac') }}</strong>
                            <div>{{ $t('language.popup.addCloudPopup.iCloudGuideMacInstructions') }}</div>
                        </div>
                        <div class="icloud-guide-description" :class="{ active: icloudGuideStep === 2 }" :aria-hidden="icloudGuideStep !== 2">
                            <div class="icloud-guide-heading">{{ $t('language.popup.addCloudPopup.iCloudGuideStep2') }}</div>
                            <div>{{ $t('language.popup.addCloudPopup.iCloudGuideStep2Instructions') }}</div>
                        </div>
                    </div>
                    <div class="icloud-guide-visual">
                        <button type="button" class="icloud-guide-arrow previous" :disabled="icloudGuideStep === 1"
                            :aria-label="$t('language.common.upStep')" :title="$t('language.common.upStep')" @click="icloudGuideStep = 1">
                            <span aria-hidden="true"></span>
                        </button>
                        <button type="button" class="icloud-guide-image"
                            :aria-label="$t('language.popup.addCloudPopup.iCloudGuideViewImage')" @click="openICloudGuidePreview">
                            <img :src="icloudGuideImage" width="424" height="260"
                                :alt="$t('language.popup.addCloudPopup.iCloudGuideImageAlt', { cloud: $t('language.addCloud.' + cloudName), step: icloudGuideStep })">
                        </button>
                        <button type="button" class="icloud-guide-arrow next" :disabled="icloudGuideStep === 2"
                            :aria-label="$t('language.common.nextStep')" :title="$t('language.common.nextStep')" @click="icloudGuideStep = 2">
                            <span aria-hidden="true"></span>
                        </button>
                    </div>
                    <div class="icloud-fields">
                        <div class="icloud-field">
                            <label for="add-icloud-name">{{ $t('language.popup.addCloudPopup.displayName') }}</label>
                            <input id="add-icloud-name" type="text" v-model="inputCloudNameValue"
                                :placeholder="$t('language.addCloud.' + cloudName)">
                        </div>
                        <div class="icloud-field">
                            <label for="add-icloud-domain">{{ $t('language.popup.domain') }}</label>
                            <input id="add-icloud-domain" type="text" v-model="domain">
                        </div>
                        <div class="icloud-field">
                            <label for="add-icloud-country">{{ $t('language.popup.addCloudPopup.iCloudAuthCountry') }}</label>
                            <select id="add-icloud-country" v-model="icloudCountry" :disabled="connect">
                                <option value="">{{ $t('language.popup.addCloudPopup.iCloudAuthCountryDefault') }}</option>
                                <option v-for="country in icloudCountries" :key="country" :value="country">
                                    {{ $t('language.popup.addCloudPopup.iCloudAuthCountries.' + country) }} ({{ country }})
                                </option>
                            </select>
                        </div>
                        <div class="icloud-field">
                            <label for="add-icloud-appleid">{{ $t('language.popup.addCloudPopup.appleId') }}</label>
                            <input id="add-icloud-appleid" type="text" v-model="appleId">
                        </div>
                        <div class="icloud-field">
                            <label for="add-icloud-password">{{ $t('language.popup.addCloudPopup.passWord') }}</label>
                            <input id="add-icloud-password" type="password" v-model="password">
                        </div>
                    </div>
                </div>
                <div class="icloud-footer">
                    <div class="icloud-actions">
                        <button v-if="cloudName === 'iCloudPhotos'" type="button" class="icloud-tips-toggle" :aria-expanded="icloudTipsShow"
                            aria-controls="icloud-format-tips" @click="icloudTipsShow = !icloudTipsShow">
                            {{ $t('language.popup.tips') }}
                            <span class="icon-util folding-panel" :class="icloudTipsShow ? 'folding-panel-up' : 'folding-panel-down'" aria-hidden="true"></span>
                        </button>
                        <button type="button" class="icloud-submit" :disabled="connect" @click="addDrive">
                            <span v-if="!connect">{{ icloudGuideTitle }}</span>
                            <span v-else>{{ $t('language.common.connecting') }}<span class="cloudDotting"></span></span>
                        </button>
                    </div>
                    <div v-if="cloudName === 'iCloudPhotos'" id="icloud-format-tips" class="icloud-format-tips" v-show="icloudTipsShow">
                        {{ $t('language.popup.addCloudPopup.iCloudPhotosGuideFormats') }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div id="addCloud" class="content" ref="addCloud" v-if="!isTempClose"
                :class="[multipleChoiceArr.includes(cloudName) ? 'amazonS3-content' : '', specialTipsCloud.includes(cloudName) ? 'threeInput-content' : '']"
                :style="{ height: tipShow ? boxHeight : getStyleHeight(cloudName) }">
                <div class="title">
                    <span> {{ $t('language.common.addCloud') }}</span>
                    <div class="icon white-close dialog-close"
                        @click="cloudDialog= false, connect = false,closeEditCloud()"></div>
                </div>
                <div class="add-cloud-cont">
                    <div class="add-cloud-cont-top">
                        <div class="add-cloud-drive-position">
                            <div class="cloud add-cloud-size" :class="cloudIcon"></div>
                            <div class="add-cloud-text">
                                {{ $t('language.addCloud.' + cloudName) }}
                            </div>
                        </div>
                    </div>
                    <div class="add-cloud-cont-body" :class="cloudName == 'amazonS3' ? 'amazonS3-body' : ''">
                           <!-- 如果云盘类型为4shared -->
                     <div class="cloud-cont add-4shared-des" v-show="cloudName == 'fourShared'">
                            <div class="icon-util egnyte-tip "> </div>
                            <div class="add-egnyteTip" style="position:relative;left:10Px;"
                                v-html="$t('language.popup.addCloudPopup.fourShared')"></div>
                    </div>
                        <div class="cloud-cont">
                            <div class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.displayName') }}</div>
                            <input :style="{ width: (this.$i18n.locale == 'italian'||(this.$i18n.locale == 'nederlands'&&cloudName === 'wasabi')) ? '450Px' : '' }" type="text"
                                v-model="inputCloudNameValue" class="cloud-cont-input"
                                :placeholder="$t('language.addCloud.' + cloudName)"
                                :class="cloudName === 'amazonS3' || cloudName === 'iDrivee2' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <!-- 如果云盘类型为webDav -->
                        <div v-show="serveCloudArr.includes(cloudName)">
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.server') }}</font>
                                <input type="text" class="ftp-cont-right-one" v-if="cloudName == 'mySQL'"
                                    v-model="serverNumber">
                                <input type="text" class="ftp-cont-right-one" v-if="cloudName != 'mySQL'"
                                    v-model="portNumber">
                                <input type="text" class="ftp-cont-input"
                                    :style="{ width: this.$i18n.locale == 'italian' ? '260Px' : '280Px' }"
                                    v-if="cloudName == 'webDav'" v-model="webDavserverHttp">
                                <input type="text" class="ftp-cont-input"
                                    :style="{ width: this.$i18n.locale == 'italian' ? '260Px' : '280Px' }"
                                    v-if="cloudName != 'webDav'" v-model="otherServerHttp">
                            </div>
                            <!-- 显示问号 -->
                            <div class="question-mark" id="cloudQuestionMark" @mouseleave="explanShow = false"
                                @mouseover="explanShow = true">
                                <div class="icon-util question three-icon-position">
                                    <div class="webdav-explanation explanation" v-if="explanShow">
                                        <font v-html="$t('language.popup.addCloudPopup.' + cloudName + 'Question')"></font>
                                    </div>
                                </div>
                            </div>
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.userName') }}</font>
                                <input type="text" :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }"
                                    v-model="username" class="cloud-cont-input">
                            </div>
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" v-model="password"
                                    type="password" class="cloud-cont-input">
                            </div>
                        </div>
                        <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                            <font class="cloud-cont-name">{{ $t('language.popup.email') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text" v-model="email"
                                class="cloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="password"
                                v-model="password" class="cloud-cont-input">
                        </div>
                        
                        <!-- 如果云盘类型为idrivee2 -->
                        <div class="cloud-cont" v-show="cloudName == 'iDrivee2'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.endpoint') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="endPoint" class="cloud-cont-input"
                                :class="cloudName == 'iDrivee2' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'iDrivee2'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.idriveKeyId') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text" v-model="accessKey"
                                class="cloud-cont-input" :class="cloudName == 'iDrivee2' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'iDrivee2'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.idriveSecretAccessKey') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="passWord"
                                v-model="secretAccessPassword" class="cloud-cont-input"
                                :class="cloudName == 'iDrivee2' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        
                        <!-- 如果云盘类型为amazons3 -->
                        <div class="cloud-cont" v-show="cloudName == 'amazonS3'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.bucketName') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="bucketName" class="cloud-cont-input"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'amazonS3'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.accessKeyId') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text" v-model="accessKey"
                                class="cloud-cont-input" :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <!-- 显示问号 -->
                        <div class="question-mark " v-show="cloudName == 'amazonS3'" id="cloudQuestionMark">
                            <div class="icon-util question three-icon-position " id="mark"> </div>
                            <div class="amazon-explanation mark-all">
                                <font v-html="$t('language.popup.addCloudPopup.amazonQuestion')"></font>
                            </div>
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'amazonS3'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.secretAccessKey') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="passWord"
                                v-model="secretAccessPassword" class="cloud-cont-input"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'amazonS3'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.endpointOptional') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="endPoint" class="cloud-cont-input"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <button class="add-drive-submit" :style="{ bottom: passwordArr.includes(cloudName) ? -5 + 'px' : '' }"
                            @click="addDrive" v-show="cloudName != 'iCloudPhotos' && cloudName != 'iCloudDrive'">
                            <span
                                v-show="!connect && !localeArr.includes($i18n.locale)">{{ $t('language.common.add') }}&nbsp;&nbsp;{{ $t('language.addCloud.' + cloudName) }}</span>
                            <span
                                v-show="!connect && localeArr.includes($i18n.locale)">{{ $t('language.addCloud.' + cloudName) }}&nbsp;&nbsp;{{ $t('language.common.add') }}</span>
                            <span v-show="connect">{{ $t('language.common.connecting') }}
                                <span class="cloudDotting"></span>
                            </span>
                        </button>

                        <!-- 如果云盘类型为ADrive -->
                        <div v-show="threeInput.includes(cloudName)">
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.email') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text" v-model="email"
                                    class="cloud-cont-input">
                            </div>
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="password"
                                    v-model="password" class="cloud-cont-input">
                            </div>
                        </div>
                    
                        <div v-show="userNameInput.includes(cloudName)">
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.userName') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                    v-model="username" class="cloud-cont-input">
                            </div>
                            <div class="cloud-cont">
                                <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                                <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="password"
                                    v-model="password" class="cloud-cont-input">
                            </div>
                        </div>

                        <!-- 如果云盘类型为backblaze -->
                        <div class="cloud-cont" v-show="cloudName == 'backblaze'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.bucketName') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="bucketName" class="cloud-cont-input"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'backblaze'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.keyID') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text" v-model="keyID"
                                class="cloud-cont-input" :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'backblaze'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.applicationKey') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="applicationKey" class="cloud-cont-input"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                        </div>

                        <div class="cloud-cont" v-if="cloudName == 'webDav' || cloudName == 'ownCloud'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.path') }}</font>
                            <input type="text" :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }"
                                v-if="cloudName == 'webDav'" v-model="path" class="cloud-cont-input">
                            <input type="text" :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }"
                                v-if="cloudName == 'ownCloud'" v-model="ownCloudpath" class="cloud-cont-input">
                        </div>

                        <div id='containerUp' class="add-cloud-info" v-show="cloudName == 'gSuite'"><span
                                v-html="$t('language.popup.addCloudPopup.gSuiteUpTips')"></span></div>
                        <div v-show="!unTips.includes(cloudName)">
                            <div style="cursor:pointer;" @click="tipShow = !tipShow"><span
                                    class="add-cloud-tips">{{ $t('language.popup.tips') }}</span>
                                <span class="icon-util folding-panel slide"
                                    :class="tipShow ? 'folding-panel-up' : 'folding-panel-down'"></span>
                            </div>
                            <div class="add-drive-footer">
                                <transition name="tip-slide" v-cloak>
                                    <div class="add-cloud-info" v-show="tipShow" id="container" ref=container>
                                        <span>{{ $t('language.popup.addCloudPopup.' + cloudName + 'Tips') | getStrValue }}</span>
                                    </div>
                                </transition>
                            </div>
                        </div>

                        <div class="cloud-cont" v-show="cloudName == 'wasabi'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.accessKeyId') }}</font>
                            <input :style="{ width: (this.$i18n.locale == 'italian'||this.$i18n.locale == 'nederlands') ? '450Px' : '' }" type="text"
                                v-model="wasabiAccessKey" class="cloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'wasabi'">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.secretAccessKey') }}</font>
                            <input :style="{ width: (this.$i18n.locale == 'italian'||this.$i18n.locale == 'nederlands') ? '450Px' : '' }" type="passWord"
                                v-model="wasabiSecretAccessPassword" class="cloud-cont-input">
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <checkAppleDialog ref="checkAppleDialog"></checkAppleDialog>
        <div v-if="isICloudGuide && icloudPreviewImage && cloudDialog && !isTempClose" class="icloud-preview" ref="icloudGuidePreview"
            role="dialog" aria-modal="true" tabindex="-1" :aria-label="$t('language.popup.addCloudPopup.iCloudGuideViewImage')"
            @click="icloudPreviewImage = false" @keydown.esc.stop="icloudPreviewImage = false">
            <img :src="icloudGuideImage" :alt="$t('language.popup.addCloudPopup.iCloudGuideImageAlt', { cloud: $t('language.addCloud.' + cloudName), step: icloudGuideStep })">
        </div>
    </div>
</template>

<script>
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";

import checkAppleDialog from '@/components/popup/add_cloud_popups/check_apple_popup';
export default {
    data: function () {
        return {
            cloudInfo: {},
            cloudDialog: false,
            cloudName: '',
            cloudIcon: '',
            email: '',
            inputCloudNameValue: '',
            bucketName: '',
            endPoint: '',
            accessKey: '',
            wasabiAccessKey: '',
            secretAccessPassword: '',
            wasabiSecretAccessPassword: '',
            connect: false,
            tipShow: false,
            unTips: commonstate.unTips,
            email: "",
            password: "",
            passwordArr: ['mega', 'mediafire',],
            boxHeight: '',
            webDavserverHttp: 'https://',
            portNumber: 443,
            advancedShow: false,
            explanShow: false, //用于定义弹框是否显示
            serveCloudArr: ['ownCloud', 'webDav', 'mySQL'],
            multipleChoiceArr: ['ownCloud', 'webDav', 'amazonS3', 'mySQL', 'backblaze', 'wasabi','iDrivee2'],
            username: '',
            serverNumber: '3306',
            otherServerHttp: '',
            domain: '',
            key: '',
            secret: '',
            threeInput: ['aDrive', 'sugarSync', 'WEBDE', 'cubby','Icedrive'], //用于表示输入项目为名称、密码、邮箱的input
            userNameInput: ['myDrive', 'yandex', 'hiDrive', 'cloudMe'], //用于表示输入项目为名称、用户名、密码的input
            path: '',
            ownCloudpath: '/remote.php/webdav/',
            keyID: '',
            applicationKey: '',
            specialTipsCloud: ['yandex', 'mediafire', 'aDrive', 'hiDrive', 'WEBDE', 'cloudMe', 'myDrive', 'cubby', 'sugarSync','Icedrive'],
            localeArr: ['deutsch', 'japanese'],
            appleId: '',
            icloudCountry: '',
            icloudCountries: ['US'],
            isTempClose: false,//是否因为其他原因临时不显示弹窗
            icloudGuideStep: 1,
            icloudTipsShow: false,
            icloudPreviewImage: false,
        }
    },
    components: {
        checkAppleDialog,
    },
    created() {
        this.unTips = commonstate.unTips;
    },
    computed: {
        isICloudGuide() {
            return this.cloudName === 'iCloudPhotos' || this.cloudName === 'iCloudDrive';
        },
        icloudGuideTitle() {
            const key = this.cloudName === 'iCloudDrive' ? 'addICloudDrive' : 'addICloudPhotos';
            return this.$t('language.popup.addCloudPopup.' + key);
        },
        icloudGuideImage() {
            return '/static/tips/AddICloud' + this.icloudGuideStep + '.png';
        },
    },
    watch: {
        cloudDialog(visible) {
            this.icloudPreviewImage = false;
            if (visible && this.isICloudGuide) {
                this.icloudGuideStep = 1;
                this.icloudTipsShow = false;
                this.icloudCountry = '';
                if (!this.domain || !this.domain.trim()) this.domain = 'www.icloud.com';
            }
        },
        cloudName(value) {
            if ((value === 'iCloudPhotos' || value === 'iCloudDrive') && (!this.domain || !this.domain.trim())) {
                this.domain = 'www.icloud.com';
            }
        },
    },
    //调整添加窗口高度
    methods: {
        openICloudGuidePreview() {
            this.icloudPreviewImage = true;
            this.$nextTick(() => {
                if (this.$refs.icloudGuidePreview) this.$refs.icloudGuidePreview.focus();
            });
        },
          // 重置输入框的值
    resetInputs() {
      this.endPoint = '';
      this.accessKey = '';
      this.secretAccessPassword = '';
      this.password = '';
      this.email = '';
      this.username = '';
      this.appleId = '';
      this.bucketName = '';
      this.keyID= '';
      this.applicationKey = '';
      this.path = '';
      this.wasabiAccessKey = '';
      this.wasabiSecretAccessPassword = '';
      this.inputCloudNameValue='';
    },
    // 关闭编辑弹框
    closeEditCloud() {
            // 关闭弹框时，将输入信息置空
            this.resetInputs();
            
    },
        getStyleHeight(cloudName) {//当tips不显示时
            let result;
            if (this.multipleChoiceArr.includes(this.cloudName)) {
                result = 445 + 'Px';
                if (this.cloudName == 'amazonS3') {
                    result = 400 + 'Px';

                } else if (this.cloudName == 'backblaze' || this.cloudName == 'iDrivee2') {
                    result = 365 + 'Px';

                } else if (this.cloudName == 'wasabi') {
                    result = 315 + 'Px';
                }
            } else if (this.cloudName == 'iCloudPhotos') {
                result = 530 + 'Px';
            } else if (this.cloudName == 'iCloudDrive') {
                result = 365 + 'Px';
            }else {
                result = 315 + 'Px';
            }
           if (
             (this.cloudName === 'iCloudPhotos' || this.cloudName === 'iCloudDrive') &&
             (!this.domain || this.domain.trim() === '') // 改进空值检查
            ) {
                this.domain = 'www.icloud.com';
            }
            return result;
        },
        emailVerification() {
            if (!commonstate.emailpattern.test(this.email.trim()) && this.email) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "addEgnyteCloud";
                } else if (this.cloudName === 'Icedrive') {
                    idValues = "addIcedriveCloud";
                } else {
                    idValues = "addCloud";
                }
                this.connect = false;
                this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: idValues
                });
                return false;
            }
        },
        addDrive() {//添加云盘
            this.connect = true;
            let that = this;
            let redirectUrl = commonstate.addCloudRedirectUrl;
            let user = commonUtils.getUserToLocal();
            let addData;
            //对输入框进行校验，如果是添加云盘的名称是空的
            if (!this.inputCloudNameValue) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "addEgnyteCloud";
                } else if (this.cloudName === 'Icedrive') {
                    idValues = "addIcedriveCloud";
                } else {
                    idValues = "addCloud";
                }
                that.$toast({
                    text: this.$t('language.exception.nameEmpty'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;//取消加载效果
                return false;
            }
            //添加云盘不支持的特殊字符
            if (commonstate.patternDriveName.test(this.inputCloudNameValue)) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "addEgnyteCloud";
                } else if (this.cloudName === 'Icedrive') {
                    idValues = "addIcedriveCloud";
                } else {
                    idValues = "addCloud";
                }
                that.$toast({
                    text: that.$t('language.home.driveNameNotContain'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;//取消加载效果
                return false;
            }
            //添加云盘为名称，邮箱，密码的云盘
            if (commonstate.threeParamDrives.includes(this.cloudName)) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "addEgnyteCloud";
                } else if (this.cloudName === 'Icedrive') {
                    idValues = "addIcedriveCloud";
                } else {
                    idValues = "addCloud";
                }
                if (!this.email) {//如果邮箱为空弹窗
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: idValues
                    });
                    this.connect = false;
                    return false;
                }
            }//如果是ownCloud和mySQL
            if (this.cloudName == 'ownCloud' || this.cloudName == 'mySQL') {
                if (!this.otherServerHttp) {//如果是otherServerHttp则弹窗
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果是需要输入用户名的云盘
            if (commonstate.userNameParamDrives.includes(this.cloudName) || this.cloudName == 'webDav' || this.cloudName == 'ownCloud' || this.cloudName == 'mySQL') {
                if (!this.username) {//如果用户名为空
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }//如果需要用户输入信息不只一条，并且用户没输入密码，则提醒用户有些参数不能为空
            if (!this.password && this.cloudName != 'amazonS3' && this.cloudName != 'iDrivee2' && this.cloudName != 'egnyte' && this.cloudName != 'backblaze' && this.cloudInfo.authParams && this.cloudInfo.authParams.length != 1) {
                let idValues;
                if (this.cloudName == 'Icedrive') {
                    idValues = "addIcedriveCloud";
                } else {
                    idValues = "addCloud";
                }
                that.$toast({
                    text: this.$t('language.exception.parametersNotEmpty'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }
            //如果是egnyte，domain不能为空
            if (this.cloudName == 'egnyte' && (!this.domain || !this.key || !this.secret)) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "addEgnyteCloud";
                } else {
                    idValues = "addCloud";
                }
                that.$toast({
                    text: this.$t('language.exception.parametersNotEmpty'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }
            //如果是amazonS3云盘，有些参数没输则弹窗提醒
            if (this.cloudName == 'amazonS3') {
                if (!this.bucketName || !this.accessKey || !this.secretAccessPassword) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果是iDrivee2云盘，有些参数没输则弹窗提醒
            if (this.cloudName == 'iDrivee2') {
                if (!this.accessKey || !this.secretAccessPassword || !this.endPoint) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果是backblaze云盘的一些参数没输入
            if (this.cloudName == 'backblaze') {
                if (!this.keyID || !this.applicationKey || !this.bucketName) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果是wasabi云盘，有些参数没输则弹窗提醒
            if (this.cloudName == 'wasabi') {
                if (!this.wasabiAccessKey || !this.wasabiSecretAccessPassword) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }

            //如果是iCloudPhotos云盘，有些参数没输则弹窗提醒
            if (this.cloudName == 'iCloudPhotos') {
                if (!this.appleId || !this.password || !this.domain) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloudPopup"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果是iCloudDrive云盘，有些参数没输则弹窗提醒
            if (this.cloudName == 'iCloudDrive') {
                if (!this.appleId || !this.password) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "addCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果输入的云盘名称超多200个字符
            if (this.inputCloudNameValue.length > 200) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "addEgnyteCloud";
                } else if (this.cloudName === 'Icedrive') {
                    idValues = "addIcedriveCloud";
                } else {
                    idValues = "addCloud";
                }
                that.$toast({
                    text: that.$t('language.home.cloudDiskName'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }
            //进行参数封装
            //若是只有一个参数
            if (!commonstate.specialDrives.includes(this.cloudName)) {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, null, null, null, null, null, null, this.cloudName, null, null, redirectUrl);
                //若含有三个参数
            } else if (commonstate.threeParamDrives.includes(this.cloudName)) {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.email, this.password, null, null, null, null, this.cloudName, null, null, redirectUrl);
                //若是其他需输入用户名云盘
            } else if (commonstate.userNameParamDrives.includes(this.cloudName)) {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.username, this.password, null, null, null, null, this.cloudName, null, null, redirectUrl);
                //若是其他特殊云盘
            } else if (this.cloudName == 'webDav') {
                let patternStpName = new RegExp("(:\\d+)?(?=((?<!\/)\/[^\/])|(\/?$))");
                let server = this.webDavserverHttp.replace(patternStpName, ':' + this.portNumber);
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.username, this.password, null, server, null, null, this.cloudName, null, this.path, redirectUrl);
            } else if (this.cloudName == 'ownCloud') {
                let patternStpName = new RegExp("(:\\d+)?(?=((?<!\/)\/[^\/])|(\/?$))");
                let server = this.otherServerHttp.replace(patternStpName, ':' + this.portNumber);
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.username, this.password, null, server, null, null, this.cloudName, null, this.ownCloudpath, redirectUrl);
            } else if (this.cloudName == 'amazonS3') {
                let server = this.endPoint;
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.accessKey, this.secretAccessPassword, null, server , null, this.bucketName, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'iDrivee2') {
                let server = this.endPoint;
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.accessKey, this.secretAccessPassword, null, server, null, null, this.cloudName, null, null,redirectUrl);
            } else if (this.cloudName == 'wasabi') {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.wasabiAccessKey, this.wasabiSecretAccessPassword, null, null, null, null, this.cloudName, null, null, redirectUrl);
            }
            else if (this.cloudName == 'mySQL') {
                let server = this.otherServerHttp + ':' + this.serverNumber;
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.username, this.password, null, server, null, null, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'egnyte') {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue,this.key, this.secret, this.domain, null, null, null, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'backblaze') {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.keyID, null, null, null, this.applicationKey, this.bucketName, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'iCloudPhotos' || this.cloudName == 'iCloudDrive') {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, this.appleId, this.password, this.domain, null, null, null, this.cloudName, null, null, redirectUrl);
                addData.country = this.icloudCountry;
                let checkApple = this.$refs.checkAppleDialog;
                //如果有验证信息
                if (checkApple.authUrl && checkApple.code) {
                    addData.authUrl = checkApple.authUrl;
                    addData.cs = checkApple.cs;
                    addData.code = checkApple.code;
                }
            } else {
                addData = new addCloudUtils.addCloudData(user.id, this.inputCloudNameValue, null, null, null, null, null, null, this.cloudName, null, null, redirectUrl);
            }
            //请求后端数据
            this.Utils.doDrivesRequest("add", addData).then(res => {
                if (res.status == 201) {//打开第三方网页
                    var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
                    localStorage.setItem(user.id + 'driveNum', allDrives.length);//用户的云盘列表长度
                    this.Utils.openWin(res);
                    this.inputCloudNameValue = '';
                    this.cloudDialog = false;
                    this.connect = false;
                } else if (res.status == 200) {//直接显示添加成功
                    if (this.cloudName == 'iCloudPhotos' || this.cloudName == 'iCloudDrive') {
                        if (res.authUrl) {
                            this.connect = false;
                            //如果是iCloudPhotos，并且返回了authUrl地址，则跳转到验证界面
                            this.$refs.checkAppleDialog.initShow(res.authUrl, this.cloudName, "add");
                            return;
                        } else {
                            //iCloudPhotos校验成功需要关闭验证弹窗
                            this.$refs.checkAppleDialog.isShow = false;
                            //重新显示弹窗
                            this.isTempClose = false;
                        }
                    }
                    this.inputCloudNameValue = '';
                    this.cloudDialog = false;
                    that.connect = false;
                    //判断是否是添加的已存在云盘，是进行提示
                    if (res.isAlready) {
                        let idValues;
                        if (this.cloudName === 'egnyte') {
                            idValues = "addEgnyteCloud";
                        } else if (this.cloudName == 'Icedrive') {
                            idValues = "addIcedriveCloud";
                        } else {
                            idValues = "addCloud";
                        }
                        this.$toast({
                            text: this.$t('language.exception.alreadyAdd'),
                            type: 'fail',
                            idValue: idValues
                        });
                    }
                    //把该返回的云盘数据存入缓存进行封装
                    addCloudUtils.putDriveToCategories(res.drive, that.cloudDialog, that);
                    //将输入信息置空
                    this.resetInputs();
                } else {
                    this.connect = false;
                    //如果是mage云盘则报以下的错
                    if (this.cloudName == 'mega' && res.reason != 'cloudNameExist') {
                        this.$toast({
                            text: this.$t('language.exception.addMegaFailed'),
                            type: 'fail',
                            idValue: "addCloud"
                        });
                    } else if(this.cloudName == 'egnyte' && res.reason == 'cloudNameExist') {
                        this.$toast({
                            text: this.$t('language.exception.alreadyAdd'),
                            type: 'fail',
                            idValue: 'addEgnyteCloud',
                        });
                     } else {
                        //如果是iCloudPhotos的验证码错误
                        if (res.reason == 'verifySecurityCodeFailed' && this.cloudName == 'iCloudPhotos') {
                            //重置验证码
                            this.$refs.checkAppleDialog.$refs.codeInput.init();
                        }
                         //如果是iCloudDrive的验证码错误
                         if(res.reason == 'verifyCodeInvalid' && this.cloudName == 'iCloudDrive'){
                            //重置验证码
                           this.$refs.checkAppleDialog.$refs.codeInput.init();
                        }
                        if (res.reason=="unknownError" && res.msg.indexOf("real:")==0) {
                            if (this.cloudName == 'Icedrive') {
                            this.$toast({
                            text: this.$t('language.exception.addCloudFailed'),
                            type: 'fail',
                            idValue: "addIcedriveCloud"
                        });
                        } else {
                            that.$toast({
                                text: res.msg.substring(5),
                                type: 'fail',
                                idValue: "addCloud",
                            });
                        }
                        } else {
                            let idValues;
                            if (this.cloudName == 'Icedrive') {
                                idValues = "addIcedriveCloud";
                            } else {
                                idValues = "addCloudPopup";
                            }
                            this.$toast({
                                text: this.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: idValues
                            });
                        
                        }
                    }
                }
            }, err => {
                this.connect = false;
            });
        },

    }
}
</script>

<style>
#addCloudPopup.icloud-popup {
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16Px;
    box-sizing: border-box;
}
#addCloud.icloud-content {
    position: relative;
    inset: auto;
    margin: 0;
    width: 760Px;
    max-width: calc(100vw - 32Px);
    min-height: 0;
    height: auto;
    max-height: calc(100vh - 32Px);
    display: flex;
    flex-direction: column;
    font-size: 14Px;
    line-height: 19Px;
}
.icloud-content > .icloud-title {
    flex: 0 0 auto;
    display: flex;
    align-items: flex-start;
    gap: 12Px;
    height: auto;
    min-height: 40Px;
    padding: 10Px 16Px 10Px 20Px;
    line-height: 20Px;
    box-sizing: border-box;
}
.icloud-title > span {
    flex: 1;
    min-width: 0;
    overflow-wrap: anywhere;
}
.icloud-title .icloud-close {
    flex: 0 0 20Px;
    height: 20Px;
    padding: 0 !important;
    background-color: transparent;
}
.icloud-body {
    flex: 1 1 auto;
    min-height: 0;
    padding: 20Px 32Px 16Px;
    overflow-y: auto;
    overflow-wrap: anywhere;
}
.icloud-guide-intro {
    margin-bottom: 16Px;
    font-size: 16Px;
    line-height: 22Px;
}
.icloud-guide-descriptions {
    display: grid;
}
.icloud-guide-description {
    grid-area: 1 / 1;
    visibility: hidden;
    pointer-events: none;
}
.icloud-guide-description.active {
    visibility: visible;
    pointer-events: auto;
}
.icloud-guide-description > strong {
    display: block;
    margin-top: 4Px;
}
.icloud-guide-heading {
    margin-bottom: 8Px;
    font-size: 16Px;
    line-height: 22Px;
}
.icloud-guide-visual {
    display: grid;
    grid-template-columns: 32Px minmax(0, 424Px) 32Px;
    align-items: center;
    justify-content: center;
    gap: 14Px;
    margin: 16Px 0 20Px;
}
.icloud-guide-visual > button {
    padding: 0 !important;
    background: transparent;
}
.icloud-guide-image {
    width: 100%;
    height: 260Px;
    cursor: zoom-in;
}
.icloud-guide-image > img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.icloud-guide-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32Px;
    height: 44Px;
    color: #5562B4;
}
.icloud-guide-arrow > span {
    display: block;
    width: 16Px;
    height: 16Px;
    border-top: 3Px solid currentColor;
    border-right: 3Px solid currentColor;
    transform: rotate(45deg);
}
.icloud-guide-arrow.previous > span {
    transform: rotate(-135deg);
}
.icloud-guide-arrow:disabled {
    color: #c6cbd6;
    cursor: not-allowed;
}
.icloud-fields {
    display: grid;
    gap: 10Px;
}
.icloud-field {
    display: grid;
    grid-template-columns: 145Px minmax(0, 1fr);
    align-items: center;
    gap: 12Px;
}
.icloud-field > input,
.icloud-field > select {
    min-width: 0;
    margin: 0;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14Px;
}
.icloud-field > select {
    width: 100%;
    height: 34Px;
    padding: 0 10Px;
    border: 1Px solid #dce5ff;
    border-radius: 0;
    background-color: #fff;
    box-sizing: border-box;
}
.icloud-field > select:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
}
.icloud-footer {
    flex: 0 0 auto;
    padding: 8Px 32Px 20Px;
}
.icloud-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16Px;
}
.icloud-actions > button {
    height: auto;
    min-height: 30Px;
    padding: 6Px 12Px !important;
    line-height: 20Px;
}
.icloud-actions .icloud-tips-toggle {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    margin-right: auto;
    gap: 8Px;
    padding-left: 0 !important;
    background: transparent;
    color: #5391f8;
}
.icloud-submit {
    min-width: 136Px;
    overflow-wrap: anywhere;
}
.icloud-submit:disabled {
    cursor: wait;
    opacity: 0.7;
}
.icloud-format-tips {
    margin-top: 12Px;
    padding: 10Px 12Px;
    max-height: 100Px;
    overflow-y: auto;
    background: #F0F8FF;
    border-radius: 4Px;
    font-size: 13Px;
    line-height: 20Px;
    overflow-wrap: anywhere;
}
.icloud-preview {
    position: fixed;
    inset: 0;
    z-index: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24Px;
    background: rgba(0, 0, 0, 0.8);
    cursor: zoom-out;
}
.icloud-preview > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
@media (max-width: 540px) {
    .icloud-body { padding: 16Px; }
    .icloud-footer { padding: 8Px 16Px 16Px; }
    .icloud-field { grid-template-columns: minmax(0, 1fr); gap: 4Px; }
    .icloud-guide-visual { gap: 8Px; }
}
#containerUp {
    margin: 10px 0 5px 0;
    /*no*/
}
.add-egnyte-des {
    color: rgba(0, 0, 0, 0.55);
    background-color: #F0F8FF;
    padding: 20px;
    border-radius: 6px;
    margin-top: -12px;
    margin-bottom: 20px;
    padding-top: 19px;
    /* 上边距较大 */
    padding-bottom: 10px;
    /* 下边距较小 */
    width: 588px !important;
}
.add-icedrive-des {
    position: absolute;
    top: -100px;
    width: 620px;
    /* height: 34px; */
    height: 37%;
    border-radius: 4px;
    opacity: 1;
    left:-1px;
    /* 自动布局 */
    display: flex;
    flex-direction: row;
    padding: 10px;
    gap: 10px;

    /* 辅助/浅蓝 */
    /* 样式描述：hover */
    background: #F2F7FC;
}


.add-4shared-des {
    color: rgba(0, 0, 0, 0.55);
    background-color: #F0F8FF;
    padding: 20px;
    border-radius: 6px;
    margin-top: 12px;
    margin-bottom: 20px;
    padding-top: 10px;
    /* 上边距较大 */
    padding-bottom: 10px;
    /* 下边距较小 */
    width: 588px !important;
}
p{
    color: red;
}
.add-egnyteTip {
    display: inline-block;
    width: 560px;
    color: black;
    letter-spacing: 0.5px;
    /* 你可以根据需要调整间隔值 */
}

.add-icedriveTip {
    position: static;
    left: -1px !important;
    top: -9px;
    width: 598px;
    height: 85px;
    opacity: 1;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 549;
    line-height: 18px;
    text-align: justify;
    letter-spacing: 0em;
    z-index: 1;
    color: #3D3D3D;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left; 
}
.text-line {
    margin: -8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/add_cloud_popup.vue